// Static content for portfolio, pricing, testimonials, FAQ
// Replace video ids and testimonial photos with real assets later.

export const PORTFOLIO = [
  {
    id: "clip-1",
    title: "Sermon Short",
    church: "Definition Church",
    duration: "Short",
    aspect: "9:16",
    youtubeId: "0MCaG7kNjW4",
    poster: "https://img.youtube.com/vi/0MCaG7kNjW4/maxresdefault.jpg",
  },
  {
    id: "clip-2",
    title: "Social Media Post",
    church: "Online Church",
    duration: "Short",
    aspect: "9:16",
    youtubeId: "5QoeGUrdMag",
    poster: "https://img.youtube.com/vi/5QoeGUrdMag/maxresdefault.jpg",
  },
  {
    id: "clip-3",
    title: "Book Promo",
    church: "Sam Luke",
    duration: "Feature",
    aspect: "16:9",
    youtubeId: "CAcc9_Gvu8g",
    poster: "https://img.youtube.com/vi/CAcc9_Gvu8g/maxresdefault.jpg",
  },
  {
    id: "clip-4",
    title: "Sermon Short",
    church: "Passion Community Church",
    duration: "Short",
    aspect: "9:16",
    youtubeId: "aRbdjyrLLCI",
    poster: "https://img.youtube.com/vi/aRbdjyrLLCI/maxresdefault.jpg",
  },
  {
    id: "clip-5",
    title: "Sermon Short",
    church: "Victory Tabernacle Church",
    duration: "Short",
    aspect: "9:16",
    youtubeId: "yP1LXLB-6nw",
    poster: "https://img.youtube.com/vi/yP1LXLB-6nw/maxresdefault.jpg",
  },
  {
    id: "clip-6",
    title: "Event Promo",
    church: "Victory Tabernacle",
    duration: "Feature",
    aspect: "16:9",
    youtubeId: "w7Ka75zfQ18",
    poster: "https://img.youtube.com/vi/w7Ka75zfQ18/maxresdefault.jpg",
  },
  {
    id: "clip-7",
    title: "Giving Campaign",
    church: "Victory Tabernacle",
    duration: "Feature",
    aspect: "16:9",
    youtubeId: "yj10i0XPkHs",
    poster: "https://img.youtube.com/vi/yj10i0XPkHs/maxresdefault.jpg",
  },
];

export const PRICING = [
  {
    slug: "starter",
    name: "Starter",
    price: "$249",
    cadence: "/ month",
    clips: "4 clips / month",
    turnaround: "72-hour turnaround",
    features: [
      "Vertical 9:16 clips for Reels, Shorts, TikTok",
      "Captions burned in",
      "Simple title card + logo",
      "One round of revisions",
    ],
    highlight: false,
  },
  {
    slug: "growth",
    name: "Growth",
    price: "$449",
    cadence: "/ month",
    clips: "8 clips / month",
    turnaround: "48-hour turnaround",
    features: [
      "Vertical + square (9:16 & 1:1)",
      "Custom captions + branded intro",
      "Thumbnail design per clip",
      "Two rounds of revisions",
      "Monthly performance recap",
    ],
    highlight: true,
    badge: "Most churches pick this",
  },
  {
    slug: "ministry-plus",
    name: "Ministry Plus",
    price: "$799",
    cadence: "/ month",
    clips: "16 clips / month",
    turnaround: "24-hour rush available",
    features: [
      "9:16, 1:1, and 16:9 versions",
      "Custom motion titles + lower thirds",
      "Direct line with dedicated editor",
      "Unlimited revisions",
      "Suggested posting schedule",
    ],
    highlight: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "We were sitting on hours of Sunday footage and never posting. Now our congregation shares clips before I've even finished my coffee on Monday.",
    name: "Pastor Daniel Reyes",
    role: "Lead Pastor",
    church: "Cedar Hollow Fellowship",
    photo:
      "https://images.unsplash.com/photo-1569292567777-e5d61a759322?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwY2h1cmNoJTIwY29tbXVuaXR5JTIwc21pbGluZ3xlbnwwfHx8fDE3ODQ1Nzg3MjZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "It feels like we finally have a media team without hiring one. The clips actually sound like our pastor — not a stock brand.",
    name: "Marissa Chen",
    role: "Communications Lead",
    church: "River & Ridge Church",
    photo:
      "https://images.pexels.com/photos/9179017/pexels-photo-9179017.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    quote:
      "Turnaround is what sold us. A sermon on Sunday morning is a Reel by Tuesday. Our volunteers can actually keep up.",
    name: "Pastor Emily Osei",
    role: "Executive Pastor",
    church: "Grace Hill Community",
    photo:
      "https://images.pexels.com/photos/8815046/pexels-photo-8815046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const FAQS = [
  {
    q: "What's the turnaround time?",
    a: "Starter is 72 hours from receiving your sermon. Growth is 48 hours. Ministry Plus includes a 24-hour rush option. If Sunday matters most to you, we plan around it.",
  },
  {
    q: "What file formats do you accept?",
    a: "Anything you already record with — MP4, MOV, a Vimeo/YouTube link, or a shared Google Drive/Dropbox folder. If you can send it to a friend, you can send it to us.",
  },
  {
    q: "Who owns the clips?",
    a: "You do. Every clip we produce is yours — no watermarks, no licensing hoops. We keep working files for 90 days in case you want an alt version.",
  },
  {
    q: "What if we don't like a clip?",
    a: "Every plan includes revisions. We'd rather remake a clip than ship one that doesn't sound like your pastor. Just tell us what feels off.",
  },
  {
    q: "Can we cancel any time?",
    a: "Yes. Month-to-month, cancel any time before your next cycle. No contracts, no exit fees, no awkward conversations.",
  },
  {
    q: "Do you work with small churches?",
    a: "That's the whole point. Most of our clients run under 300 in weekly attendance. Starter was built specifically for smaller teams.",
  },
];

export const MARQUEE_WORDS = [
  "Vertical clips",
  "Reels · Shorts · TikTok",
  "48-hour turnaround",
  "Made for small churches",
  "Captions included",
  "Your pastor's voice",
  "No watermarks",
  "Month-to-month",
];
